/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
import {
  ISpinnerStyleProps,
  ISpinnerStyles,
  IStyleFunctionOrObject,
} from "@fluentui/react";
import { ITimelineStyles } from "./Timeline.types";

// eslint-disable-next-line @typescript-eslint/ban-types
export const timeLineStyle: IStyleFunctionOrObject<{}, ITimelineStyles> = {
  root: {
    flex: 1,
    paddingLeft: 24,
    "@media screen and (min-width: 320px) and (max-width: 1023px)": {
      paddingLeft: 0,
      marginRight: 0,
    },
  },
  paraGraphText: {
    fontSize: 14,
    marginTop: 34,
    paddingLeft: 25,
  },
  divContainer: {
    "@media screen and (min-width: 1024px)": {
      maxHeight: 248,
      overflowY: "auto",
    },
  },
  ulContainer: {
    listStyleType: "none",
    position: "relative",
    "> :not(:first-child)": {
      marginTop: 40,
    },
    "::before": {
      content: "''",
      background: "#d4d9df",
      display: "inline-block",
      position: "absolute",
      left: 30,
      width: 2,
      height: "100%",
      zIndex: 400,
    },
  },
  liContainer: {
    margin: "20px 0",
    paddingLeft: 20,
    lineHeight: "1",
  },
  liContent: {
    marginLeft: -37,
  },
  textContainer: {
    marginLeft: 48,
    display: "flex",
  },
  statusText: {
    marginRight: 24,
    fontSize: 14,
  },
  downloadText: {
    fontSize: 14,
    display: "flex",
    cursor: "pointer",
  },
  downloadSubText: {
    marginLeft: 8,
    marginRight: 8,
  },
  downloadLink: {
    textDecoration: "none",
    fontSize: 14,
  },
  declineStatusText: {
    marginLeft: 48,
    fontSize: 14,
    display: "flex",
  },
  greenIcon: {
    color: "#107C10",
    zIndex: 400,
    position: "absolute",
    boxShadow:
      "0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.00), 0 3px 0 4px rgba(0, 0, 0, 0.00)",
  },
  redIcon: {
    color: "#A80000",
    zIndex: 400,
    position: "absolute",
    boxShadow:
      "0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.00), 0 3px 0 4px rgba(0, 0, 0, 0.00)",
  },
  downloadIcon: {
    color: "#0078d4",
  },
  spinnerContainer: {
    display: "flex",
    marginTop: "unset",
    justifyContent: "center",
  },
  pendingText: {
    margin: "0px",
    fontSize: "12px",
    color: "#646464",
    fontWeight: 400,
    marginTop: "10px",
    paddingLeft: 25,
    "@media screen and (min-width: 320px) and (max-width: 1023px)": {
      paddingLeft: 0,
    },
  },
};

export const spinnerStyle: IStyleFunctionOrObject<
  ISpinnerStyleProps,
  ISpinnerStyles
> = {
  root: {
    flexDirection: "row-reverse",
  },
  label: {
    marginTop: "unset",
    marginBottom: "unset",
    marginRight: 8,
    flex: "2 1 0",
  },
};
